import http from './http';

const gpaForecastServices = {
  // async getGpaForeCastById(gpa_forecast_id: any) {
  //   const res = await http.get(`api/gpa-forecast/${gpa_forecast_id}`);
  //   return res;
  // },

  async getGpaForeCast(student_id: any) {
   const body = {
      student_id: student_id
   };
    const res = await http.post(`api/gpa-forecast/search/by_student_id`, body);  
    return res;
  },

  async getGpaForeCastByGradeNo(studentId:any, gradeNo: number) {
    const body = {
      student_id: Number(studentId ?? 0),
      grade_no: gradeNo
    };
     const res:any[] = await http.post(`api/gpa-forecast/search/by_grade_no`, body);  
     return res;
   },

  /**
   * Update a coursework block. Added 2026-09-24 for the annual-credit toggle on
   * the V2 forecaster (ClickUp #86ak9ab4g).
   *
   * Hits PUT api/gpa-forecast, which validates the caller against body.student_id
   * and then calls updateByStudent. That lookup is by (student_id, seq_no,
   * grade_no), so all three must be in the body or the wrong block is matched.
   * The update is a partial merge, so any key left out is preserved.
   */
  async updateGpaForeCast(body: any) {
    const res = await http.put(`api/gpa-forecast`, body);
    return res;
  },

  async syncGpaForecast(studentId: any) {
    const res = await http.get(`api/grade-and-college-course/sync_gpa_forecast/${studentId}`);
    return res;
  },

  async syncGpaForecastGradeNo(studentId: any, gradeNo:number) {
    const body = {
      student_id: Number(studentId ?? 0),
      grade_no: gradeNo
    };
    const res = await http.post('api/grade-and-college-course/sync_gpa_forecast', body);
    return res;
  },

  async createGpaForeCast(body: any) {
    const res = await http.post('api/gpa-forecast', body);
    return res;
  },

  async resolveForecastId(
    studentId: any,
    gradeNo: number,
    schoolName: string,
    extras: {
      school_code?: string;
      school_year?: string;
      schedule?: string;
      grading_scale?: string;
    } = {}
  ): Promise<number> {
    const sid = Number(studentId ?? 0);
    const name = (schoolName || '').trim().toLowerCase();
    const forecasts: any[] = await this.getGpaForeCastByGradeNo(sid, gradeNo).catch(() => []);
    const match =
      forecasts.find((f) => String(f.school_name || '').trim().toLowerCase() === name) ||
      forecasts[0];
    const existingId = Number(match?.gpa_forecast_id);
    if (Number.isFinite(existingId) && existingId > 0) {
      return existingId;
    }

    const nextSeq = forecasts.reduce((max, f) => Math.max(max, Number(f.seq_no) || 0), 0) + 1;
    const created: any = await this.createGpaForeCast({
      student_id: sid,
      seq_no: nextSeq,
      grade_no: gradeNo,
      school_name: (schoolName || '').trim(),
      school_code: extras.school_code ?? '',
      school_year: extras.school_year ?? '',
      schedule: extras.schedule ?? 'Semester',
      grading_scale: extras.grading_scale ?? 'A-F',
    });
    const fromCreate = Number(created?.gpa_forecast_id);
    if (Number.isFinite(fromCreate) && fromCreate > 0) {
      return fromCreate;
    }

    const again: any[] = await this.getGpaForeCastByGradeNo(sid, gradeNo).catch(() => []);
    const found =
      again.find((f) => String(f.school_name || '').trim().toLowerCase() === name) ||
      again[again.length - 1];
    const id = Number(found?.gpa_forecast_id);
    if (!Number.isFinite(id) || id <= 0) {
      throw new Error('Could not create GPA forecast parent row');
    }
    return id;
  },

};

export default gpaForecastServices;
